export default __webpack_public_path__ + "static/media/buyerChoice.a3bfc1a3.svg";